module.exports = __webpack_public_path__ + "static/media/candy-cane.d4c013ee.svg";